import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { PieChart, Users, Coins, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';
import TokenomicsPieChart from '@/components/ui/TokenomicsPieChart';
import { tokenConfig } from '@/constants';

const TokenomicsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });



  return (
    <section id="tokenomics" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-6 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
            <img src="/images/logo.svg" alt="FoodSply" className="h-10 md:h-[56px]" />
            <span>Tokenomics</span>
          </h2>
          <div className="max-w-4xl mx-auto text-left space-y-4">
            <p className="text-gray-700 leading-relaxed">
              The Foodsply blockchain allows you to review transaction history. Transform Real World Assets (RWA) into digital versions that are interoperable.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Foodsply D.A.O provides a 1% distribution strictly to food allocation. Hex tiles represent 
              an area on the global map where agriculture is taking place. Users can tour the map to 
              view different regions around the world and gain real-time insight with regards to 
              agriculture and what's being grown through dash board analytics.
            </p>
          </div>
        </motion.div>

        {/* Token Details Table */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-16"
        >
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
            <div className="bg-gradient-to-r from-foodsply-green to-foodsply-orange p-4">
              <h3 className="text-2xl font-bold text-white">TOKEN DETAILS</h3>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <tbody className="divide-y divide-gray-200">
                  <tr className="hover:bg-gray-50">
                    <td className="px-3 sm:px-6 py-4 font-semibold text-gray-900 bg-gray-50">Role of Token</td>
                    <td className="px-3 sm:px-6 py-4 text-gray-700">
                      <ul className="space-y-2 sm:space-y-1">
                        {tokenConfig.roles.map((role, index) => (
                          <li key={index} className="flex items-start">
                            <span className="w-2 h-2 bg-foodsply-green rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
                            <span className="text-sm sm:text-base">{role}</span>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-semibold text-gray-900 bg-gray-50">Token Supply</td>
                    <td className="px-6 py-4 text-gray-700">{tokenConfig.totalSupply} Billion</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-semibold text-gray-900 bg-gray-50">Blockchain</td>
                    <td className="px-6 py-4 text-blue-600 font-medium">{tokenConfig.blockchain}</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-semibold text-gray-900 bg-gray-50">Consensus Method</td>
                    <td className="px-6 py-4 text-gray-700">{tokenConfig.consensus}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </motion.div>

        {/* Token Distribution Chart */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mb-16"
        >
          <TokenomicsPieChart />
        </motion.div>


      </div>
    </section>
  );
};

export default TokenomicsSection;